import classNames from "classnames";
import React, { Component, Fragment } from "react";
import ReactPlayer from "react-player";
import { MainStore } from "../../stores/MainStore";
import classes from "./styles.module.scss";

interface IProps {
  autoplay?: boolean;
  expandable?: boolean;
  store: MainStore;
}
interface State {
  videoReady: boolean;
}
class VideoPlayer extends Component<
  IProps & React.HTMLAttributes<HTMLVideoElement>
> {
  state = {
    videoReady: false
  };
  config() {
    const { expandable } = this.props;
    return {
      youtube: {
        playerVars: {
          controls: 0,
          showinfo: 0
        },
        embedOptions: {
          controls: false
        }
      },
      vimeo: {
        playerOptions: {
          autopause: 1,
          background: expandable ? 1 : 0,
          texttrack: "en"
        }
      }
    };
  }
  render() {
    const videoClass = classNames(classes.VideoPlayer);
    const { videoReady } = this.state;
    const { autoplay, expandable, store } = this.props;
    if (!store) return null;

    const { selectedState } = store;
    if (!selectedState) return null;

    if (expandable && !selectedState) return null;
    return (
      <Fragment>
        <div className={videoClass}>
          {!videoReady && (
            <div className={classes.VideoPreloaderContainer}>
              <div className={classes.VideoPreloader} />
            </div>
          )}
          <ReactPlayer
            url={selectedState.videoUrl}
            playing={videoReady && (autoplay || false)}
            width="100%"
            height="100%"
            config={this.config()}
            muted={false}
            loop={expandable}
            controls={!expandable}
            volume={1}
            onDuration={e => this.setState({ videoReady: true })}
          />
          {expandable && (
            <div
              className={classes.VideoOverlay}
              onClick={e => {
                store.openStateDetail(selectedState);
              }}
            />
          )}
        </div>
      </Fragment>
    );
  }
}
export default VideoPlayer;
